import { jsonMember, jsonObject } from 'typedjson';
import { Id } from '@shared/types/id';

@jsonObject
export class SequenceCollectionItemResponse {
  @jsonMember readonly id!: Id;
  @jsonMember readonly name!: string;
  @jsonMember readonly createdAt!: Date;
  @jsonMember readonly generatedAt!: Date;
  @jsonMember({ name: 'comment' }) readonly description!: string;
}
